import useTransformNewspaperTableData from './useTransformNewspaperTableData'

export default useTransformNewspaperTableData
